'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/shortid/index.js
// module id = 17
// module chunks = 0